<template>
  <a-row>
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1">
      <a-tabs
        :key="$route.fullPath"
        v-model="tabPane"
        class="main-tabs contacts-form-content"
        type="card"
        @change="tabPaneChangeHandler"
      >
        <a-tab-pane key="content">
          <span slot="tab">
            <a-icon type="project" />
            {{ $route.meta.title[$i18n.locale] }}
          </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Язык:</a-col
            >
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- address -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Адрес:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.address[langTab]"
                placeholder="Введите адрес"
              />
            </a-col>
          </a-row>

          <!-- office number -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Канцелярия:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.office"
                placeholder="Введите номер канцелярия"
                @keypress="isNumber"
              />
            </a-col>
          </a-row>

          <!-- phone number -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Телефон:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.phone"
                placeholder="Введите номер телефона"
                @keypress="isNumber"
              />
            </a-col>
          </a-row>

          <!-- fax number -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Факс:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input v-model="form.fax" placeholder="Введите номер факса" />
            </a-col>
          </a-row>

          <!-- bus -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Автобусы:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.bus[langTab]"
                placeholder="Введите номера автобусов"
              />
            </a-col>
          </a-row>

          <!-- minibus -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Маршрутки:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.minibus[langTab]"
                placeholder="Введите номера маршруток"
              />
            </a-col>
          </a-row>

          <!-- subway -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Метро:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.subway[langTab]"
                placeholder="Введите номера метро"
              />
            </a-col>
          </a-row>

          <!-- reference point -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Ориентир:</a-col
            >
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.reference_point[langTab]"
                placeholder="Введите ориентир"
              />
            </a-col>
          </a-row>

          <!-- work times -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Рабочая время:</a-col
            >
            <a-col :span="8" class="sm-mb">
              <!-- Week days -->

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[1][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.monday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[2][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.tuesday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[3][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.wednesday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[4][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.thursday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[5][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.friday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[6][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.saturday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <a-row align="middle" class="mb-2" type="flex">
                <span class="mr-1 gray-text short-day-names text-center">{{
                  shortDayName[7][$i18n.locale]
                }}</span>

                <a-input
                  v-model="form.sunday"
                  class="time-picker-input__style"
                  placeholder="Введите время"
                  @keypress="isTimeInput"
                />
              </a-row>

              <!--            <a-row align="middle" class="mb-2" type="flex" v-for="(day, index) in 6">-->
              <!--              <span-->
              <!--                class="mr-1 gray-text short-day-names text-center">{{ shortDayName[index + 1][$i18n.locale] }}</span>-->
              <!--              <a-time-picker :defaultValue="moment('09:00', 'HH:mm')"-->
              <!--                             @change="onTimePick('fromTime', index, arguments)"-->
              <!--                             class="time-picker-input__style"-->
              <!--                             format="HH:mm"/>-->
              <!--              <span class="mx-1"></span>-->
              <!--              <a-time-picker :defaultValue="moment('18:00', 'HH:mm')"-->
              <!--                             @change="onTimePick('toTime', index, arguments)"-->
              <!--                             class="time-picker-input__style"-->
              <!--                             format="HH:mm"/>-->
              <!--            </a-row>-->
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />Сохранить
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  data: () => ({
    langTab: $langPrefix,
    tabPane: "content",
    pending: false,
    loading: false,
    form: {
      address: {
        uz: "",
        oz: "",
        ru: "",
        en: ""
      },
      phone: "",
      office: "",
      fax: "",

      bus: "",
      minibus: "",
      subway: "",
      reference_point: "",

      lat_lng: {
        lat: 41.304656,
        lng: 69.264127
      },

      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
      sunday: ""
    },
    weekDays: {
      monday: {
        fromTime: "",
        toTime: ""
      },
      tuesday: {
        fromTime: "",
        toTime: ""
      },
      wednesday: {
        fromTime: "",
        toTime: ""
      },
      thursday: {
        fromTime: "",
        toTime: ""
      },
      friday: {
        fromTime: "",
        toTime: ""
      },
      saturday: {
        fromTime: "",
        toTime: ""
      },
      sunday: {
        fromTime: "",
        toTime: ""
      }
    }
  }),
  computed: {
    dayNamesList() {
      return Object.keys(this.weekDays)
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const r = await this.$api.get("/contact/get")

        // console.log(r);
        if (r && r.data) {
          this.$set(this, "form", {
            ...r.data,
            address: {
              ...this.langKeys,
              ...((r.data.address && JSON.parse(r.data.address)) ||
                this.form.address)
            },

            bus: {
              ...this.langKeys,
              ...((r.data.bus && JSON.parse(r.data.bus)) || this.form.bus)
            },
            minibus: {
              ...this.langKeys,
              ...((r.data.minibus && JSON.parse(r.data.minibus)) ||
                this.form.minibus)
            },

            subway: {
              ...this.langKeys,
              ...((r.data.subway && JSON.parse(r.data.subway)) ||
                this.form.subway)
            },

            reference_point: {
              ...this.langKeys,
              ...((r.data.reference_point &&
                JSON.parse(r.data.reference_point)) ||
                this.form.reference_point)
            }
          })
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }

      this.loading = false
    },
    // eslint-disable-next-line no-unused-vars
    onTimePick(keyName, index, [time, e]) {
      // console.log('timepicker', keyName, index, time, e)

      this.weekDays[this.dayNamesList[index]][keyName] = e || ""

      const a = Object.entries(this.weekDays) || []

      a.map(([dayName, { fromTime, toTime }]) => {
        this.form[dayName] = fromTime.concat(" " + toTime)
      })
    },
    tabPaneChangeHandler(arg) {
      this.tabPane = arg
    },

    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.address[from]) {
          this.form.address[to] = this[methodName](this.form.address[from])
        }
      } catch (error) {
        console.log("translitAction error", error)
      }
    },

    async submit() {
      this.pending = true
      try {
        const r = await this.$api.post("/contact/create", {
          ...this.form,
          address: JSON.stringify(this.form.address),
          bus: JSON.stringify(this.form.bus),
          minibus: JSON.stringify(this.form.minibus),
          subway: JSON.stringify(this.form.subway),
          reference_point: JSON.stringify(this.form.reference_point)
        })
        if (r) {
          this.$message.success("Контакты сохранены")
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    }
  }
}
</script>
